// extracted by mini-css-extract-plugin
export var body = "_le-0";
export var sectionHeader = "_le-4";
export var shortcutColumns = "_le-2";
export var shortcutList = "_le-1";
export var shortcutSection = "_le-3";